import React, { ReactNode } from 'react';
import { Table } from 'reactstrap';
import Loading from './Loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export interface TableVerticalInfoObject {
    header: string
    content: ReactNode
    className?: string
}

interface TableVerticalProps {
    searching: boolean
    error: boolean
    info: TableVerticalInfoObject[]
    header: string
    displayToggle?: boolean
    show?: boolean
    toggle?: () => void
}

const TableVertical: React.FC<TableVerticalProps> = (props: TableVerticalProps) => {
    const { t } = useTranslation('common');

    const renderBody = () => {
        return (<>
            <Table className="info_table">
                <tbody>
                    {props.info && props.info.map((row, i) =>
                        <tr key={i}>
                            <th className={row.className}>{row.header}</th>
                            <td data-label={row.header}>{row.content ?? '-'}</td>
                        </tr>
                    )}
                </tbody>
            </Table>
            {props.searching && <Loading />}
            {props.error && <p>{t('error.couldNotFetch', { ns: 'common' })}</p>}
            {!props.error && !props.searching && !props.info.length && <p>{t('noResult', { ns: 'common' })}</p>}
        </>)
    }

    return (
        <div>
            <div className="header_member_table">{props.header}
                {props.displayToggle ?
                    <div onClick={props.toggle} className="right">
                        {props.show ? <FontAwesomeIcon title={t('displayToggle.hide', { ns: 'common' })} icon="chevron-down" /> : <FontAwesomeIcon title={t('displayToggle.show', { ns: 'common' })} icon="chevron-right" />}
                    </div> : null}
            </div>

            {props.displayToggle ?
                props.show && renderBody()
                :
                renderBody()}

        </div>
    )
}

export default TableVertical;
